<!-- 个人信息 -->
<template>
  <div class="el-userInfo">
    <el-row class="page_content">
      <h1 class="head_title">基本信息</h1>
      <el-descriptions :colon="false">
        <el-descriptions-item label="姓名：">{{userInfo.studentName}}</el-descriptions-item>
        <el-descriptions-item label="考生号：">{{userInfo.studentTestNo}}</el-descriptions-item>
      </el-descriptions>
      <el-descriptions :colon="false">
        <el-descriptions-item label="学号：">{{userInfo.studentNo}} </el-descriptions-item>
        <el-descriptions-item label="身份证号：">{{userInfo.studentIdCard}} </el-descriptions-item>
      </el-descriptions>
      <el-descriptions :colon="false">
        <el-descriptions-item label="学籍状态：">
          {{$studentState(userInfo.studentStatusState)}}</el-descriptions-item>
        <el-descriptions-item label="政治面貌：">{{userInfo.studentPoliticalOutlook}}</el-descriptions-item>
      </el-descriptions>
      <el-descriptions :colon="false">
        <el-descriptions-item label="性别：">{{userInfo.studentSex == 1?"男":userInfo.studentSex == 2?"女":"保密"}}
        </el-descriptions-item>
        <el-descriptions-item label="邮政编码：">{{userInfo.postalCode}}</el-descriptions-item>
      </el-descriptions>
      <el-descriptions :colon="false">
        <el-descriptions-item label="民族：">{{userInfo.studentNation}}</el-descriptions-item>
        <el-descriptions-item label="联系电话：">{{userInfo.studentPhone}}</el-descriptions-item>
      </el-descriptions>
      <el-descriptions :colon="false">
        <el-descriptions-item label="出生年月：">{{$timeFormat(userInfo.studentBirthday, 'yyyy-MM-dd')}}</el-descriptions-item>
        <el-descriptions-item label="电子邮箱：">{{userInfo.studentEmail}}</el-descriptions-item>
      </el-descriptions>
      <el-descriptions :colon="false" v-if="!this.$strExistHostnameOnce(['lfjtysxx'])">
        <el-descriptions-item label="报考学校：">{{userInfo.targetUniversityName}}</el-descriptions-item>
        <el-descriptions-item label="工作单位：">{{userInfo.studentJobAddress}}</el-descriptions-item>
      </el-descriptions>
      <el-descriptions :colon="false" class="lxdz" v-if="!this.$strExistHostnameOnce(['lfjtysxx'])">
        <el-descriptions-item label="联系地址：">{{userInfo.studentAddress}}</el-descriptions-item>
        <el-descriptions-item label="QQ 群：" v-if="this.$strExistHostnameOnce(['xttc'])">{{QQGroup}}</el-descriptions-item>
      </el-descriptions>

      <h1 class="head_title" style="margin-top:20px;">专业信息</h1>
      <el-descriptions :colon="false">
        <el-descriptions-item label="年级：">{{userInfo.grade}}</el-descriptions-item>
        <el-descriptions-item label="学习形式：">{{userInfo.learningModalityConcat}}</el-descriptions-item>
      </el-descriptions>
      <el-descriptions :colon="false">
        <el-descriptions-item label="专业名称：">{{userInfo.professionalName}}</el-descriptions-item>
        <el-descriptions-item label="层次：">{{userInfo.cultivationLevelConcat}}</el-descriptions-item>
      </el-descriptions>
      <el-descriptions :colon="false">
        <el-descriptions-item label="学制：">{{userInfo.professionalLength}}</el-descriptions-item>
        <el-descriptions-item label="函授站：">{{userInfo.corSchoolName}}</el-descriptions-item>
      </el-descriptions>
      <el-descriptions :colon="false" class="lxdz">
        <el-descriptions-item label="入学日期：">{{userInfo.admissionDate}}</el-descriptions-item>
      </el-descriptions>
      <el-button round class="but" @click="editUserInfo">修 改</el-button>
    </el-row>
    <el-dialog title="" :visible.sync="show" width="700px">
      <el-form ref="form" :rules="rules" label-position="right" :model="form" label-width="100px">
        <el-form-item label="邮政编号：">
          <el-input v-model="form.postalCode" autocomplete="off"></el-input>
        </el-form-item>
        <template v-if="!isPhoneValidator">
            <el-form-item label="联系电话：" prop="phone">
              <el-input v-model="form.studentPhone" maxlength="11"></el-input>
            </el-form-item>
        </template>
        <el-form-item label="电子邮箱：" prop="email">
          <el-input v-model="form.studentEmail"></el-input>
        </el-form-item>
        <el-form-item label="工作单位：">
          <el-input v-model="form.studentJobAddress"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="show = false">取 消</el-button>
        <el-button type="primary" @click="submitInfo" :loading="submitBut">提 交</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
  import {
    isvalidPhone
  } from '../../common/validate';
  var validPhone = (rule, value, callback) => {
    if (!value) {
      callback();
    } else if (!isvalidPhone(value)) {
      callback(new Error('请输入正确的11位手机号码'));
    } else {
      callback();
    }
  }
  export default {
    name: "UserInfo",
    data() {
      return {
        show: false,
        userInfo: {},
        form: {
          postalCode: "",
          studentEmail: "",
          studentPhone: "",
          studentJobAddress: "",
          type: []
        },
        submitBut: false,
        rules: {
          studentEmail: [{
              required: true,
              message: '请输入邮箱地址',
              trigger: 'blur'
            },
            {
              type: 'email',
              message: '请输入正确的邮箱地址',
              trigger: ['blur', 'change']
            }
          ],

          // studentPhone: [{
          //     trigger: 'blur',
          //     validator: validPhone
          //   } //这里需要用到全局变量
          // ]
        },
        isPhoneValidator: true, //是否开启手机验证
        QQGroup:null
      };
    },
    created() {
      this.getPersonalInfo();
      this.getStuNewVerifyPhoneOpenConfig();
    },
    methods: {
        getStudentQQGroupInfo(corSchoolId){ //根据correspondenceSchoolId获取QQ群信息
            this.$store.dispatch("user/getStudentQQGroupInfo",{correspondenceSchoolId:corSchoolId}).then((ret) => {
                if(ret.code == 0){
                    this.QQGroup = ret.data;
                }
            })
        },
        getStuNewVerifyPhoneOpenConfig(){ //是否开启短信验证 开启了手机校验，不让在个人信息更改，关了可以改
            this.$store.dispatch("user/getStuNewVerifyPhoneOpenConfig").then((ret) => {
                if(ret.code == 0){
                    this.isPhoneValidator = ret.data; // true开启 false为关闭
                }
            })
        },
        editUserInfo() {
            this.form.postalCode = this.userInfo.postalCode;
            this.form.studentEmail = this.userInfo.studentEmail;
            this.form.studentPhone = this.userInfo.studentPhone;
            this.form.studentJobAddress = this.userInfo.studentJobAddress;
            this.show = true;
        },
      getPersonalInfo() {
            this.loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            this.$store.dispatch("user/getPersonalInfo").then((ret) => {
                this.loading.close();
            if (ret.code === 0 || ret.code === '0') {
                this.userInfo = ret.data;
                if(this.$strExistHostnameOnce(['xttc'])){ //邢台才显示QQ群信息
                      this.getStudentQQGroupInfo(ret.data.corSchoolId);
                }
            } else {
                this.$message({message: ret.msg,type: 'warning'});
            }
            }).catch(() => {
                this.loading.close();
            });
      },
      submitInfo() {
        if(this.isPhoneValidator){
            delete this.form.studentPhone;
        }else{
            if(!isvalidPhone(this.form.studentPhone)){
                this.$message({
                  showClose: true,
                  message: "请输入正确的电话号码！",
                  type: 'warning'
                });
                return;
            }
        }
        this.submitBut = true;
        this.$store.dispatch("user/editPersonalInfo", this.form)
        .then((ret) => {
          this.submitBut = false;
          this.$message({
            showClose: true,
            message: ret.msg,
            type: ret.code == 0?'success':'warning'
          });
          if(ret.code == 0){
            this.show = false;
            this.getPersonalInfo();
          }
        }).catch(() => {
          this.submitBut = false;
        });
      }
    }
  };
</script>
<style lang="less">
  @import '../../styles/base.less';

  .el-userInfo {
    .page_content {
      padding: 0 20px 20px;
    }

    .el-descriptions-item__label {
      white-space: nowrap;
      width: 80px;
      text-align: right;
      padding-top: 10px;
    }

    .el-descriptions-item__container {
      font-size: 15px;
    }

    .el-descriptions-item__content {
      width: 40%;
      border-bottom: 1px solid #b0b0b0;
      padding: 10px 0 5px 10px;
      font-weight: 600;
    }

    .el-descriptions {
      padding-left: 35px;
    }

    .lxdz {
      .el-descriptions-item__content {
        width: 60%;
      }
    }

    .but {
      background-color: rgb(0, 191, 191);
      color: white;
      font-size: 15px;
      padding: 12px 30px;
      position: fixed;
      right: 50px;
      bottom: 50px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/user/UserInfo.vue